import 'zone.js';
import { bootstrapApplication, provideClientHydration } from '@angular/platform-browser';
import { App } from './app/app';
import { appConfig } from './app/app.config';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient, withFetch } from '@angular/common/http';
import { provideZoneChangeDetection } from '@angular/core';


bootstrapApplication(App, {
  ...appConfig,
  providers: [
    ...(appConfig.providers ?? []),
    provideAnimations(),
    provideClientHydration(),
    provideZoneChangeDetection({
      eventCoalescing: true
    }),
    provideHttpClient(withFetch()),
  ],
}).catch(err => console.error(err));